module.exports = __webpack_public_path__ + "static/media/carousel_2.3536be3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/carousel_2.jpg
// module id = 166
// module chunks = 0